module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-minus-194f36b851763f1cd961bc0fe866a408.svg";